import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as nls from '../../../nls.js';
import { EditorAction, registerEditorAction } from '../../browser/editorExtensions.js';
import { StopWatch } from '../../../base/common/stopwatch.js';

var ForceRetokenizeAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(ForceRetokenizeAction, _EditorAction);

  var _super = _createSuper(ForceRetokenizeAction);

  function ForceRetokenizeAction() {
    _classCallCheck(this, ForceRetokenizeAction);

    return _super.call(this, {
      id: 'editor.action.forceRetokenize',
      label: nls.localize('forceRetokenize', "Developer: Force Retokenize"),
      alias: 'Developer: Force Retokenize',
      precondition: undefined
    });
  }

  _createClass(ForceRetokenizeAction, [{
    key: "run",
    value: function run(accessor, editor) {
      if (!editor.hasModel()) {
        return;
      }

      var model = editor.getModel();
      model.resetTokenization();
      var sw = new StopWatch(true);
      model.forceTokenization(model.getLineCount());
      sw.stop();
      console.log("tokenization took ".concat(sw.elapsed()));
    }
  }]);

  return ForceRetokenizeAction;
}(EditorAction);

registerEditorAction(ForceRetokenizeAction);